/* eslint-disable react/no-unescaped-entities */
import { Button } from '@mui/material';
import DownloadIcon from 'assets/icons/DownloadIcon';
import { StudioIcon } from 'assets/icons';
import {
  ExampleBox,
  ExampleBoxGrid,
  ExampleBoxLight,
  ExampleBoxLightGrid,
  ExampleBoxSmall,
  StyledContainer,
} from '../styled';

const ButtonsDemoSection = () => (
  <>
    <StyledContainer>
      <h1>Buttons & Links</h1>
      <p>
        Buttons should look like buttons, and links should look like links.
        There is a difference;
      </p>
      <ol>
        <li>
          A button usually indicates something will happen when the user clicks
          it
        </li>
        <li>
          A link indicates a user will go somewhere after it has been clicked
        </li>
      </ol>
      <p>
        So from a UX perspective, we should make sure we are using the correct
        element.
      </p>
      <h2>Primary button</h2>
      <p>
        The primary button should always use the primary brand colour, unless
        specified otherwise. This button should be used for the primary action
        within a user journey.
      </p>
      <p>Examples:</p>
      <ExampleBox>
        <Button variant="rounded">Primary (rounded)</Button>
        <Button variant="rounded" startIcon={<DownloadIcon />}>
          Primary (rounded) With Icon
        </Button>
        <Button variant="rounded" disabled>
          Primary (rounded) Disabled
        </Button>
      </ExampleBox>

      <p>
        In some instances, we need a button to span the full width of a
        container, e.g., The generate button within vega, and buttons for small
        screens.
      </p>
      <ExampleBoxSmall>
        <Button variant="rounded" fullWidth>
          Primary Button Full Width
        </Button>
      </ExampleBoxSmall>
      <h2>Secondary (outlined) button</h2>
      <p>
        The secondary button should always appear as an outlined button and used
        for actions that offer an alternative to the primary action - hence
        there is less visual emphasis.
      </p>
      <p>Dark mode examples:</p>
      <ExampleBox>
        <Button variant="outlined">Secondary (outlined)</Button>
        <Button variant="outlined" startIcon={<StudioIcon />}>
          Secondary (outlined) with Icon
        </Button>
        <Button variant="outlined" disabled>
          Secondary (outlined) disabled
        </Button>
      </ExampleBox>

      <p>Light mode examples:</p>
      <ExampleBoxLight>
        <Button variant="outlinedDark">Secondary Dark</Button>
        <Button variant="outlinedDark" startIcon={<StudioIcon />}>
          Secondary Dark with Icon
        </Button>
        <Button variant="outlinedDark" disabled>
          Secondary Dark disabled
        </Button>
      </ExampleBoxLight>

      <h2>Text only buttons</h2>
      <p>
        These types of buttons can be used along side Primary or Secondary
        buttons to provide an alternative option, e.g., 'Cancel', or 'Dismiss'
        within a modal window. These can also be used at the top of a list as
        access to filters. These can be used in a variety of colours.
      </p>
      <p>Examples:</p>
      <p>Dark mode examples:</p>
      <ExampleBox>
        <Button variant="text">Text Only</Button>
        <Button variant="text" startIcon={<DownloadIcon />}>
          Text With Icon
        </Button>
        <Button variant="text" disabled>
          Text Only disabled
        </Button>
      </ExampleBox>
      <p>Light mode examples:</p>
      <ExampleBoxLight>
        <Button variant="textDark">Text Dark Only</Button>
        <Button variant="textDark" startIcon={<DownloadIcon />}>
          Text Dark With Icon
        </Button>
        <Button variant="textDark" disabled>
          Text Dark Only disabled
        </Button>
      </ExampleBoxLight>

      <h2>Plain Text buttons</h2>
      <p>Examples:</p>
      <p>Dark mode examples:</p>
      <ExampleBoxGrid>
        <Button variant="plainText">Plain Text</Button>
        <Button variant="plainText" startIcon={<DownloadIcon />}>
          Plain Text With Icon
        </Button>
        <Button variant="plainText" disabled>
          Plain Text Only disabled
        </Button>
      </ExampleBoxGrid>
      <p>Light mode examples:</p>
      <ExampleBoxLightGrid>
        <Button variant="plainTextDark">Plain Text Dark</Button>
        <Button variant="plainTextDark" startIcon={<DownloadIcon />}>
          Plain Text Dark With Icon
        </Button>
        <Button variant="plainTextDark" disabled>
          Plain Text Dark Only disabled
        </Button>
      </ExampleBoxLightGrid>
    </StyledContainer>
  </>
);

export default ButtonsDemoSection;
